import { Injectable } from '@angular/core';

/**
 * Native port of the v1 `versionSelection` factory (account-v1/src/components/
 * version-panel/version-panel.js:66-110) over the v1 `sessionStorage` service's
 * JSON envelope (core/storage/sessionStorage.js: put = JSON.stringify, get =
 * `item && JSON.parse(item) || null`). WS5 #10 Stage A inc 2w: replaces the
 * `$injector.get('versionSelection')` grab in ft-touchpoint-messaging
 * (ft-touchpoint-integration next).
 *
 * SHARED-KEY LOAD-BEARING (the SnapshotService precedent): the raw
 * `poststay-version` sessionStorage key + JSON serialization are kept verbatim —
 * the still-v1 touchpoint-styling controller and the v1 version-panel directive
 * read/write the SAME key until their own drains/Stage B.
 *
 * Verbatim quirk kept: v1's `if (angular.isDefined(savedSelection) == false)
 * return current` is DEAD (the storage get returns null, never undefined, and
 * isDefined(null) is true) — the no-saved-selection case instead falls through
 * to the includes() check (null is not in the list) and returns `current` from
 * the LAST line. Same observable result, same structure.
 */
@Injectable({ providedIn: 'root' })
export class VersionSelectionService {
  private static readonly KEY = 'poststay-version';

  /** v1 VersionSelection.update — save the user's selection. */
  update(newVersion: any): void {
    sessionStorage.setItem(VersionSelectionService.KEY, JSON.stringify(newVersion));
  }

  /** v1 VersionSelection.get(selection, current, installed). */
  get(selection: any, current: any, installed: any): any {
    if (selection !== undefined) return selection;

    const item = sessionStorage.getItem(VersionSelectionService.KEY);
    const savedSelection = (item && JSON.parse(item)) || null;
    if ((savedSelection !== undefined) == false) return current; // dead v1 branch — kept verbatim

    if ([current, installed].includes(savedSelection)) return savedSelection;

    return current;
  }

  /** v1 VersionSelection.clear. */
  clear(): void {
    sessionStorage.removeItem(VersionSelectionService.KEY);
  }
}
